import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractTime'
})
export class ExtractTimePipe implements PipeTransform {

  transform(value: string, args: string[]) : string {
    if(value.indexOf(".")>0)
      return value.slice(value.indexOf(" ")+1,value.indexOf("."));
    else 
      return value.slice(value.indexOf(" ")+1,value.length);
  }

}
